import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import Cookies from 'js-cookie';
import React, { useEffect } from 'react';
import { Post } from 'Xhr/Xhr';

const useFetchMyTurns = (setMyTurns, forceRender) => {
  const user =
    Cookies.get('user') && JSON.parse(Cookies.get('user'));

  useEffect(() => {
    Post(
      'POST',
      `${process.env.REACT_APP_API_URL_API_GET_MY_NOBAT}`,
      true,
      {
        idPatient: user?.IdPatient,
      }
    ).then((response) => {
      console.log('response data is =>', response);
      if (response.data.resCode === 1) {
        setMyTurns(response.data.Data);
      } else {
        SwalAlert('error', response.data.resMessage, false);
      }
    });
  }, [forceRender]);
};

export default useFetchMyTurns;
